document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) return;

  const productImages = document.querySelectorAll('.product-gallery img, .product-media img, .product__media img, .product-block img');
  
  productImages.forEach(function(img) {
    const container = img.closest('modal-opener, a, .product__media-item, .product-media, [data-media-id]') || img.parentElement;
    if (!container) return;
    
    // Forzamos que el contenedor sostenga nuestro escudo exactamente sobre la imagen
    if (window.getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }
    
    const loupe = document.createElement('div');
    loupe.className = 'image-loupe';
    document.body.appendChild(loupe);
    
    // CREAMOS EL ESCUDO FÍSICO
    const shield = document.createElement('div');
    shield.className = 'zoom-click-shield';
    container.appendChild(shield);
    
    let isZoomActive = false;
    
    function getHighResUrl(url) {
      let cleanUrl = url.split('?')[0];
      return cleanUrl.replace(/_[0-9]+x[0-9]+(?!.*_[0-9]+x[0-9]+)(\.[a-zA-Z]+)$/, '$1');
    }

    function updateLoupe(e) {
      if (window.innerWidth <= 768) return;
      
      const rect = img.getBoundingClientRect();
      if (rect.width === 0) return;
      
      const rawX = e.clientX - rect.left;
      const rawY = e.clientY - rect.top;

      const edgeMargin = window.themeZoomEdgeMargin !== undefined ? window.themeZoomEdgeMargin : 30;
      
      // Apagado suave en los bordes
      if (
        rawX < edgeMargin || 
        rawX > (rect.width - edgeMargin) || 
        rawY < edgeMargin || 
        rawY > (rect.height - edgeMargin)
      ) {
        loupe.classList.remove('is-active');
        return; 
      } else {
        const activation = window.themeZoomActivation || 'hover';
        if (activation === 'hover' || isZoomActive) {
          loupe.classList.add('is-active');
        }
      }

      const trackingSpeed = window.themeZoomTrackingSpeed || 1.0;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      let deltaX = rawX - centerX;
      let deltaY = rawY - centerY;
      
      deltaX *= trackingSpeed;
      deltaY *= trackingSpeed;
      
      const effectiveX = Math.min(Math.max(centerX + deltaX, 0), rect.width);
      const effectiveY = Math.min(Math.max(centerY + deltaY, 0), rect.height);

      const scale = window.themeZoomScale || 2.5;
      const engine = window.themeZoomEngine || 'lens';
      
      if (window.themeZoomSmoothness) {
        loupe.classList.add('is-smooth');
      } else {
        loupe.classList.remove('is-smooth');
      }
      
      const loupeWidth = loupe.offsetWidth;
      const loupeHeight = loupe.offsetHeight;
      
      loupe.style.left = (e.clientX - (loupeWidth / 2)) + 'px';
      loupe.style.top = (e.clientY - (loupeHeight / 2)) + 'px';
      
      loupe.style.backgroundSize = `${rect.width * scale}px auto`;
      
      if (engine === 'lens') {
        const bgX = -((effectiveX * scale) - (loupeWidth / 2));
        const bgY = -((effectiveY * scale) - (loupeHeight / 2));
        loupe.style.backgroundPosition = `${bgX}px ${bgY}px`;
      } else {
        const xPercent = (effectiveX / rect.width) * 100;
        const yPercent = (effectiveY / rect.height) * 100;
        loupe.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
      }
    }

    // Leemos tu panel de control
    setTimeout(() => {
      if (window.themeZoomActivation === 'click') {
        container.classList.add('zoom-click-enabled');
      }
    }, 100);

    // --- MAGIA: EL PRIMER CLIC (Lo atrapa el escudo de cristal) ---
    shield.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) return;
      const activation = window.themeZoomActivation || 'hover';
      
      if (activation === 'click') {
        // Matamos el evento para que Shopify no se entere
        e.preventDefault();
        e.stopPropagation();
        
        isZoomActive = true;
        container.classList.add('zoom-is-on');
        loupe.classList.add('is-active');
        
        // "Rompemos" el escudo quitándolo del camino
        shield.style.display = 'none';
        
        const highResImg = getHighResUrl(img.src);
        loupe.style.backgroundImage = `url('${highResImg}')`;
        updateLoupe(e);
      }
    });

    // --- MAGIA: EL SEGUNDO CLIC (El escudo ya no está, así que este clic pasa libre) ---
    container.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) return;
      const activation = window.themeZoomActivation || 'hover';

      if (activation === 'click' && isZoomActive) {
        // Solo apagamos nuestra lupa, dejamos que Shopify abra la imagen
        isZoomActive = false;
        loupe.classList.remove('is-active');
        container.classList.remove('zoom-is-on');
      }
    });

    container.addEventListener('mouseenter', function(e) {
      if (window.innerWidth <= 768) return;
      const activation = window.themeZoomActivation || 'hover';
      
      const highResImg = getHighResUrl(img.src);
      loupe.style.backgroundImage = `url('${highResImg}')`;

      if (activation === 'hover') {
        loupe.classList.add('is-active');
        updateLoupe(e);
      } else if (activation === 'click' && !isZoomActive) {
        // Aseguramos que el escudo esté encendido al entrar
        shield.style.display = ''; 
      }
    });
    
    container.addEventListener('mouseleave', function() {
      loupe.classList.remove('is-active');
      isZoomActive = false;
      container.classList.remove('zoom-is-on');
      shield.style.display = ''; // Restauramos el escudo para el siguiente usuario
    });
    
    container.addEventListener('mousemove', function(e) {
      const activation = window.themeZoomActivation || 'hover';
      if (activation === 'hover' || (activation === 'click' && isZoomActive)) {
        updateLoupe(e);
      }
    });
  });
});